/* eslint-disable css-modules/no-undef-class */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './circle-loader.scss';
import PROGRESS_STATE from '../../constants/progressStateConstants';

const { NONE, LOADING, FAILED, SUCCESS } = PROGRESS_STATE;

export default class CircleLoader extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    large: PropTypes.bool,
    placeholder: PropTypes.bool,
    progress: PropTypes.oneOf([
      NONE,
      LOADING,
      FAILED,
      SUCCESS,
    ]),
  };

  static defaultProps = {
    className: '',
    large: false,
    placeholder: false,
    progress: NONE,
  };

  isProgress(checkState) {
    const { progress } = this.props;
    return checkState === progress;
  }

  render() {
    const { className, large, placeholder } = this.props;

    return (
      <div
        className={classNames(className, styles.circleLoader, {
          [styles.loadFailed]: this.isProgress(FAILED),
          [styles.loading]: this.isProgress(LOADING) || this.isProgress(SUCCESS),
          [styles.thick]: large,
          [styles.placeholder]: placeholder,
        })}
        data-test="circle-loader"
      >
        <div
          className={classNames({
            [styles.cross]: this.isProgress(FAILED),
            [styles.crossDraw]: this.isProgress(FAILED),
            [styles.visible]: this.isProgress(SUCCESS) || this.isProgress(FAILED),
            [styles.thick]: large,
          })}
          data-test="inner-circle-loader"
        />
      </div>
    );
  }
}
